export default __webpack_public_path__ + "static/media/Dazzed-SemiBold.37e76e24.otf";